import React, { useEffect, useState, useCallback } from 'react';
import DataTable from './DataTable';
import axiosInstance from '../utils/axiosInstance';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const RejectedRequests = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRejectedRequests = useCallback(async () => {
    try {
      const response = await axiosInstance.get('/request/rejected'); 
      
      const filteredAndSorted = response.data
        .filter(request => request.status === 'rejected')
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); // 🆕 Tarih Sıralaması

      setData(filteredAndSorted);
      setLoading(false);
    } catch (error) {
      console.error("Hata:", error);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRejectedRequests();
  }, [fetchRejectedRequests]);

  if (loading) return <div className="data-page-container"><p>Yükleniyor...</p></div>;

  return (
    <div className="page-content-wrapper">
      <DataTable 
        title="İptal Edilen Talepler" 
        data={data} 
        isPendingPage={false} 
        fetchData={fetchRejectedRequests} 
      />
      {/* ToastContainer burada bir kez tanımlanmalı */}
      <ToastContainer 
        theme="dark" 
        position="top-right" 
        autoClose={2000} 
        limit={3} // Üst üste binmeyi engeller
      />
    </div>
  );
};

export default RejectedRequests;